<ion-list mode="ios" lines="none" class="list-content">
  <ion-item lines="none" mode="md" color="white">
    <ion-label color="status-icon-enable" class="font-weight-600">
      {{ 'Labels.' + (isBonus ? 'cancel-bonus' : 'cancel-promotion') | translate
      }}
    </ion-label>
  </ion-item>

  <ion-item lines="none" mode="md" color="white">
    <ion-label color="grayDemon" class="cancel-promo">
      <p>
        {{ 'Labels.' + (isBonus ? 'have-already-started-together-bonus' :
        'have-already-started-together-promotion') | translate }}
      </p>

      <p>{{ 'Labels.are-you-sure-want-out' | translate }}</p>
    </ion-label>
  </ion-item>

  <ion-item lines="none" mode="md" color="white">
    <ion-button
      mode="md"
      color="white"
      size="default"
      expand="block"
      (click)="onClose(true)"
      class="buttons"
    >
      <ion-label color="tpcta" class="ion-text-capitalize">
        {{ 'Buttons.leave' | translate }}
      </ion-label>
    </ion-button>

    <ion-button
      mode="md"
      color="tpcta"
      size="default"
      expand="block"
      (click)="onClose(false)"
      class="buttons"
    >
      <ion-label color="white" class="ion-text-capitalize">
        {{ 'Buttons.cancel' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
